import React from 'react'
import { ThemeProvider } from '@mui/material/styles';
import { CustomTheme, cacheRtl } from './CustomTheme'
import { WbContextProvider } from './Context/MainContext'
import { BrowserRouter } from "react-router-dom";
import MyRouter from './Router/MyRouter';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

// import { CacheProvider } from '@emotion/react';

export default function App() {
    return (
        <>
            <WbContextProvider>
                {/* <CacheProvider value={cacheRtl}> */}
                    <ThemeProvider theme={CustomTheme}>
                        <ToastContainer
                          position="top-center"
                          autoClose={3000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={true}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="light"
                        />
                        <BrowserRouter>
                            <MyRouter />
                        </BrowserRouter>
                    </ThemeProvider>
                {/* </CacheProvider> */}
            </WbContextProvider>
        </>
    )
}
